/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ImageGalleryCategory {
    "use strict";

    export class ImageGalleryCategoryContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public filter: string;
        protected translate: any;
        protected totalAssociatedImages: number= 0;
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            $translate: angular.translate.ITranslateService) {
                super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
                this.baseEndpoint = this.appSettings.API_ENDPOINTS.imageGalleryCategory;
                this.sectionTemplatePath = "app/plugins/imageGalleryCategory/sectionViews/";
                this.buildCrudSecurityKeys(this.securityKeys.DATA_IMAGEGALLERYCATEGORY_TAB_MAIN);
                this.entityType = 'ImageGalleryCategory';
                this.translate = $translate;
                
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_IMAGEGALLERYCATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "Main", "main.html", true, false, this.appSettings.API_ENDPOINTS.imageGalleryCategory, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ImageGalleryCategory, null, this.securityKeys.DATA_IMAGEGALLERYCATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.totalAssociatedImages = model.totalAssociatedImages;
            this.deleteConfirmationMessageKey = model.totalAssociatedImages?
                    this.translate.instant("MESSAGE_IMAGEGALLERYCAT_DELETE_CONFIRMATION",
                    { totalAssociatedImages: model.totalAssociatedImages }) :
                "MESSAGE_DELETE_CONFIRMATION" ;
        }

        hasAssociatedImages(): void {
              
            if (this.selectedSection.model.objectState == Model.ObjectStateEnum.Active && this.totalAssociatedImages > 0) {
                this.modalService.confirmHandler(this.translate.instant("MESSAGE_IMAGEGALLERYCAT_DELETE_CONFIRMATION",{ totalAssociatedImages: this.totalAssociatedImages }),
                        Meevo.Components.Modal.ModalTranslationModes.Translate)
                    .then((response: boolean) => {
                        if (!response) {
                            this.selectedSection.model.objectState = Model.ObjectStateEnum.Active;
                        }
                    });
            }
        };


    }
}